import { render, staticRenderFns } from "./EditorBlockRecordAudio.vue?vue&type=template&id=1e778134"
import script from "./EditorBlockRecordAudio.vue?vue&type=script&lang=js"
export * from "./EditorBlockRecordAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports